import BaseAPIService from '@/services/baseAPIService'

export default class AutomationAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  getComponentTypeList(params = {}) {
    return this.httpClient.get(`/automations/componenttypes?` + $.param(params))
  }
  getComponentType(id)        { return this.httpClient.get(`/automations/componenttypes/${id}`) }

  // Rules
  createAutomationRule(data)            { return this.httpClient.post(`/automations/rules`, data) }
  getAutomationRule(id)                 { return this.httpClient.get(`/automations/rules/${id}`) }
  updateAutomationRule(id, data)        { return this.httpClient.put(`/automations/rules/${id}`, data) }
  deleteAutomationRule(id)              { return this.httpClient.delete(`/automations/rules/${id}`) }

  trigerAutomationRule(id)              { return this.httpClient.post(`/automations/rules/${id}/trigger`) }

  getAutomationRuleLogList(id)          { return this.httpClient.get(`/automations/rules/${id}/logs`) }

  // Extra Services
  calculatePlaceholderList(data)        { return this.httpClient.post(`/automations/rules/placeholders/calculate`, data) }
}
